import React from 'react'
import dayjs from 'dayjs'
import { Icon } from '@mobi/component-library/Common/V2/Icon'
import { hexColors } from '@mobi/settings/hexColors'
import { ExpandablePanelThemes } from '@core/Components/ExpandablePanel/themes'
import { CompactPanel } from '@core/Components/Panel'
import { useStewardsComments } from '@core/Areas/Racing/Hooks/useStewardsComments'
import { StewardsCommentsStyled, StewardsCommentTextStyled } from './StewardsComments.styles'

type Props = {
  meetingId: string
  meetingDate: Date
  raceNumber: number
}

const StewardsComments = ({ meetingId, meetingDate, raceNumber }: Props): JSX.Element | null => {
  const { hasValidStewardsComments, stewardsComments: comments } = useStewardsComments({
    meetingId,
    meetingDate,
    raceNumber,
  })

  if (!hasValidStewardsComments) return null

  return (
    <CompactPanel
      headerIcon={<Icon name='SolidFile06' size='1.8rem' color={hexColors.blueDiamond} />}
      headerText='Stewards Comments'
      themeName={ExpandablePanelThemes.lavender}
    >
      <StewardsCommentsStyled>
        {comments.map(({ acceptorName, comment, timestamp }, i) => (
          <li key={i}>
            <StewardsCommentTextStyled>
              <strong>{acceptorName}:</strong> {comment}{' '}
              <time dateTime={timestamp}>{dayjs(timestamp).format('DD MMM YY[.]')}</time>
            </StewardsCommentTextStyled>
          </li>
        ))}
      </StewardsCommentsStyled>
    </CompactPanel>
  )
}

export default StewardsComments
